module.exports = __webpack_public_path__ + "static/scale-model-of-old-mill-park-in-sandy-springs-georgia-aa3a291567219b7b4e7c9109d6ad3d2c.png";